// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============ Formulaires (entreprise, etc.) ============ */
.entreprise-logo-preview {
    max-width: 200px;
    max-height: 150px;
    object-fit: cover;
    border: 1px solid var(--color-border);
    border-radius: var(--bs-border-radius);
    background: var(--color-surface);
    padding: 4px;
}

/* Champs de formulaire cohérents avec le reste de l'app */
.form-control,
.form-select {
    border-radius: var(--bs-border-radius);
    border-color: var(--color-border);
}

.form-control:focus,
.form-select:focus {
    border-color: var(--bs-primary);
    box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.15);
}

.form-label {
    color: var(--color-ink-soft);
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/createOrUpdate.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;IAChC,YAAY;AAChB;;AAEA,0DAA0D;AAC1D;;IAEI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;;IAEI,+BAA+B;IAC/B,0DAA0D;AAC9D;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB","sourcesContent":["/* ============ Formulaires (entreprise, etc.) ============ */\n.entreprise-logo-preview {\n    max-width: 200px;\n    max-height: 150px;\n    object-fit: cover;\n    border: 1px solid var(--color-border);\n    border-radius: var(--bs-border-radius);\n    background: var(--color-surface);\n    padding: 4px;\n}\n\n/* Champs de formulaire cohérents avec le reste de l'app */\n.form-control,\n.form-select {\n    border-radius: var(--bs-border-radius);\n    border-color: var(--color-border);\n}\n\n.form-control:focus,\n.form-select:focus {\n    border-color: var(--bs-primary);\n    box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.15);\n}\n\n.form-label {\n    color: var(--color-ink-soft);\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
